/**
* @file UserListView.js

* @author - Team D(Meeramol Mathew),TeamE(Keerthana,Karpakam)    
* @sprint - B2W-Sprint-5
* @description - 
* This component displays data in a tabular format using Ant Design's Table component.
* It includes functionalities for  editing and deleting.
*/

import React, { useEffect, useState } from "react";
import { Table, Space, Tooltip, Popconfirm, Button, notification } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import moment from "moment";
import UserAccountActivityLabels from "../../pages/UserAccountActivityLabels.json";

const { Column } = Table;

const UserListView = ({ data, onEdit, onDelete }) => {

    const [isAdmin, setIsAdmin] = useState(false);
    console.log("Showing :", data);

    useEffect(() => {
        const roleUser = JSON.parse(localStorage.getItem("userRoles"));

        if (roleUser && roleUser.includes("ADMINUSER")) {
            setIsAdmin(true);
        }
    }, []);

    /**
      * Handles editing a record.
      * @param {Object} record - The record to edit.
      */
    const handleEdit = (record) => {
        console.log("Editing Record:", record);
        onEdit(record);
    };

    /**
     * Handles deleting a record.
     * @param {Object} record - The record to delete.
     */
    const handleDelete = (record) => {
        console.log("Deleting Record:---------------", record);
        onDelete(record);
    };


    return (
        <div className={isAdmin ? "mt-10" : ""}>
            <div className="bg-white shadow-lg rounded-lg overflow-hidden min-h-[400px]">
                {/* Conditionally apply margin-top based on isAdmin */}

                {/* Table Component */}
                <Table

                    dataSource={data}
                    rowKey="id"
                    // className="w-full"
                    scroll={{ x: 1000, y: 250 }}
                    //scroll={{ x: true }} // Enables horizontal scrolling if needed
                    pagination={{ pageSize: 5 }}
                    components={{
                        header: {
                            wrapper: (props) => (
                                <thead {...props} className="bg-[var(--color-primary)] text-white" />
                            ),
                        },
                    }}
                >
                    {/* Activity Column */}
                    <Column
                        title={UserAccountActivityLabels.ActivityTitile}
                        dataIndex="activityName"
                        key="activityName"
                        width={300}
                        align="left"
                    />

                    {/* Activity Start Date Column */}
                    <Column
                        title={UserAccountActivityLabels.ActivityStartDate}
                        dataIndex="activityStartDate"
                        key="activityStartDate"
                        width={200}
                        align="left"
                        render={(text) => moment(text, "DD-MM-YYYY").format("DD MMM YYYY")}
                    />
                    {/* Activity End Date Column */}
                    <Column
                        title={UserAccountActivityLabels.ActivityEndDate}
                        dataIndex="activityEndDate"
                        key="activityEndDate"
                        width={200}
                        align="left"
                        render={(text) => moment(text, "DD-MM-YYYY").format("DD MMM YYYY")}
                    />



                    {/* Conditionally render the Action Column based on isAdmin */}
                    {!isAdmin && (
                        <Column
                            title={UserAccountActivityLabels.ActionTitle}
                            key="action"
                            width={200}
                            align="center"
                            render={(_, record) => (
                                <Space size="middle">

                                    {/* Edit Button */}
                                    {/* <Tooltip title={UserAccountActivityLabels.EditAction}>
                                <button
                                    onClick={() => handleEdit(record)}
                                    className="p-2 text-green-500 transition hover:text-green-700 w-10"
                                >
                                    <EditOutlined className="text-lg" />
                                </button>
                            </Tooltip> */}
                                    {/* Delete Button with Confirmation */}
                                    <Tooltip title={UserAccountActivityLabels.DeleteAction}>
                                        <Popconfirm
                                            title="Are you sure you want to delete this record?"
                                            okText="Yes"
                                            cancelText="No"
                                            onConfirm={() => handleDelete(record)}
                                            onCancel={() =>
                                                notification.warning({
                                                    message: "Cancelled",
                                                    description: "Delete action was cancelled.",
                                                    placement: "topRight",
                                                    btn: (
                                                        <Button type="primary" size="small" onClick={() => notification.destroy()}>
                                                            {UserAccountActivityLabels.Button_Ok}
                                                        </Button>
                                                    ),
                                                })
                                            }
                                        >
                                            <button className="p-2 text-red-500 transition hover:text-red-700 w-20">
                                                <DeleteOutlined className="text-lg" />
                                            </button>
                                        </Popconfirm>
                                    </Tooltip>
                                </Space>
                            )}
                        />
                    )}
                </Table>
            </div>
        </div>
    );

};
export default UserListView;